import AddCategoryMedicalStore from "../pages/medicalStore/master/categoryMedicalStore/add";
import ListCategoryMedicalStore from "../pages/medicalStore/master/categoryMedicalStore/list";
import EditCategoryMedicalStore from "../pages/medicalStore/master/categoryMedicalStore/edit";

import AddMedicineComposition from "../pages/medicalStore/master/medicineComposition/add";
import ListMedicineComposition from "../pages/medicalStore/master/medicineComposition/list";
import EditMedicineComposition from "../pages/medicalStore/master/medicineComposition/edit";

import AddPharmaCompany from "../pages/medicalStore/master/pharmaCompany/add";
import ListPharmaCompany from "../pages/medicalStore/master/pharmaCompany/list";
import EditPharmaCompany from "../pages/medicalStore/master/pharmaCompany/edit";

import AddMedicineGroup from "../pages/medicalStore/master/medicineGroup/add";
import ListMedicineGroup from "../pages/medicalStore/master/medicineGroup/list";
import EditMedicineGroup from "../pages/medicalStore/master/medicineGroup/edit";

import AddItem from "../pages/medicalStore/master/item/add";
import ListItem from "../pages/medicalStore/master/item/list";
import EditItem from "../pages/medicalStore/master/item/edit";

import AddPurchaseBillEntry from "../pages/medicalStore/transaction/purchaseBillEntry/add";
import ListPurchaseBillEntry from "../pages/medicalStore/transaction/purchaseBillEntry/list";
import EditPurchaseBillEntry from "../pages/medicalStore/transaction/purchaseBillEntry/edit";

import AddPurchaseBillReturnEntry from "../pages/medicalStore/transaction/purchaseBillReturnEntry/add";
import ListPurchaseBillReturnEntry from "../pages/medicalStore/transaction/purchaseBillReturnEntry/list";
import EditPurchaseBillReturnEntry from "../pages/medicalStore/transaction/purchaseBillReturnEntry/edit";

import AddSaleBillEntry from "../pages/medicalStore/transaction/saleBillEntry/add";
import ListSaleBillEntry from "../pages/medicalStore/transaction/saleBillEntry/list";
import EditSaleBillEntry from "../pages/medicalStore/transaction/saleBillEntry/edit";

import AddSaleBillReturnEntry from "../pages/medicalStore/transaction/saleBillReturnEntry/add";
import ListSaleBillReturnEntry from "../pages/medicalStore/transaction/saleBillReturnEntry/list";
import EditSaleBillReturnEntry from "../pages/medicalStore/transaction/saleBillReturnEntry/edit";

import AddIssueReceiveEntry from "../pages/medicalStore/transaction/issueReceiveEntry/add";
import ListIssueReceiveEntry from "../pages/medicalStore/transaction/issueReceiveEntry/list";
import EditIssueReceiveEntry from "../pages/medicalStore/transaction/issueReceiveEntry/edit";

import AddDepartmentIssueEntry from "../pages/medicalStore/transaction/departmentIssueEntry/add";
import ListDepartmentIssueEntry from "../pages/medicalStore/transaction/departmentIssueEntry/list";
import EditDepartmentIssueEntry from "../pages/medicalStore/transaction/departmentIssueEntry/edit";

import AddEstimateEntry from "../pages/medicalStore/transaction/estimateEntry/add";
import ListEstimateEntry from "../pages/medicalStore/transaction/estimateEntry/list";
import EditEstimateEntry from "../pages/medicalStore/transaction/estimateEntry/edit";

import AddStockTransferEntry from "../pages/medicalStore/transaction/stockTransferEntry/add";
import ListStockTransferEntry from "../pages/medicalStore/transaction/stockTransferEntry/list";
import EditStockTransferEntry from "../pages/medicalStore/transaction/stockTransferEntry/edit";

export const medicalStoreMasterRoutes = [
  // category
  {
    path: `/medical-store/master/category/add`,
    Component: <AddCategoryMedicalStore />,
    permission: "category.add"
  },
  {
    path: `/medical-store/master/category/list`,
    Component: <ListCategoryMedicalStore />,
    permission: "category.list"
  },
  {
    path: `/medical-store/master/category/edit/:id`,
    Component: <EditCategoryMedicalStore />,
    permission: "category.edit"
  },

  // medicine-composition
  {
    path: `/medical-store/master/medicine-composition/add`,
    Component: <AddMedicineComposition />,
    permission: "medicinecomposition.add"
  },
  {
    path: `/medical-store/master/medicine-composition/list`,
    Component: <ListMedicineComposition />,
    permission: "medicinecomposition.list"
  },
  {
    path: `/medical-store/master/medicine-composition/edit/:id`,
    Component: <EditMedicineComposition />,
    permission: "medicinecomposition.edit"
  },

  // pharma-company
  {
    path: `/medical-store/master/pharma-company/add`,
    Component: <AddPharmaCompany />,
    permission: "pharmacompany.add"
  },
  {
    path: `/medical-store/master/pharma-company/list`,
    Component: <ListPharmaCompany />,
    permission: "pharmacompany.list"
  },
  {
    path: `/medical-store/master/pharma-company/edit/:id`,
    Component: <EditPharmaCompany />,
    permission: "pharmacompany.edit"
  },

  // medicine-group
  {
    path: `/medical-store/master/medicine-group/add`,
    Component: <AddMedicineGroup />,
    permission: "medicinegroup.add"
  },
  {
    path: `/medical-store/master/medicine-group/list`,
    Component: <ListMedicineGroup />,
    permission: "medicinegroup.list"
  },
  {
    path: `/medical-store/master/medicine-group/edit/:id`,
    Component: <EditMedicineGroup />,
    permission: "medicinegroup.edit"
  },

  // item
  {
    path: `/medical-store/master/item/add`,
    Component: <AddItem />,
    permission: "item.add"
  },
  {
    path: `/medical-store/master/item/list`,
    Component: <ListItem />,
    permission: "item.list"
  },
  {
    path: `/medical-store/master/item/edit/:id`,
    Component: <EditItem />,
    permission: "item.edit"
  }
];

export const medicalStoreTransactionRoutes = [
  // purchase-bill-entry
  {
    path: `/medical-store/transaction/purchase-bill-entry/add`,
    Component: <AddPurchaseBillEntry />,
    permission: "purchasebill.add"
  },
  {
    path: `/medical-store/transaction/purchase-bill-entry/list`,
    Component: <ListPurchaseBillEntry />,
    permission: "purchasebill.list"
  },
  {
    path: `/medical-store/transaction/purchase-bill-entry/edit/:id`,
    Component: <EditPurchaseBillEntry />,
    permission: "purchasebill.edit"
  },

  // purchase-bill-return-entry
  {
    path: `/medical-store/transaction/purchase-bill-return-entry/add`,
    Component: <AddPurchaseBillReturnEntry />,
    permission: "purchasebillreturn.add"
  },
  {
    path: `/medical-store/transaction/purchase-bill-return-entry/list`,
    Component: <ListPurchaseBillReturnEntry />,
    permission: "purchasebillreturn.list"
  },
  {
    path: `/medical-store/transaction/purchase-bill-return-entry/edit/:id`,
    Component: <EditPurchaseBillReturnEntry />,
    permission: "purchasebillreturn.edit"
  },

  // sale-bill-entry
  {
    path: `/medical-store/transaction/sale-bill-entry/add`,
    Component: <AddSaleBillEntry />,
    permission: "salebill.add"
  },
  {
    path: `/medical-store/transaction/sale-bill-entry/list`,
    Component: <ListSaleBillEntry />,
    permission: "salebill.list"
  },
  {
    path: `/medical-store/transaction/sale-bill-entry/edit/:id`,
    Component: <EditSaleBillEntry />,
    permission: "salebill.edit"
  },

  // sale-bill-return-entry
  {
    path: `/medical-store/transaction/sale-bill-return-entry/add`,
    Component: <AddSaleBillReturnEntry />,
    permission: "salebillreturn.add"
  },
  {
    path: `/medical-store/transaction/sale-bill-return-entry/list`,
    Component: <ListSaleBillReturnEntry />,
    permission: "salebillreturn.list"
  },
  {
    path: `/medical-store/transaction/sale-bill-return-entry/edit/:id`,
    Component: <EditSaleBillReturnEntry />,
    permission: "salebillreturn.edit"
  },

  //issue-receive-entry
  {
    path: `/medical-store/transaction/issue-receive-entry/add`,
    Component: <AddIssueReceiveEntry />,
    permission: "issuereceive.add"
  },
  {
    path: `/medical-store/transaction/issue-receive-entry/list`,
    Component: <ListIssueReceiveEntry />,
    permission: "issuereceive.list"
  },
  {
    path: `/medical-store/transaction/issue-receive-entry/edit/:id`,
    Component: <EditIssueReceiveEntry />,
    permission: "issuereceive.edit"
  },

  //department-issue-entry
  {
    path: `/medical-store/transaction/department-issue-entry/add`,
    Component: <AddDepartmentIssueEntry />,
    permission: "departmentissue.add"
  },
  {
    path: `/medical-store/transaction/department-issue-entry/list`,
    Component: <ListDepartmentIssueEntry />,
    permission: "departmentissue.list"
  },
  {
    path: `/medical-store/transaction/department-issue-entry/edit/:id`,
    Component: <EditDepartmentIssueEntry />,
    permission: "departmentissue.edit"
  },

  //estimate-entry
  {
    path: `/medical-store/transaction/estimate-entry/add`,
    Component: <AddEstimateEntry />,
    permission: "estimate.add"
  },
  {
    path: `/medical-store/transaction/estimate-entry/list`,
    Component: <ListEstimateEntry />,
    permission: "estimate.list"
  },
  {
    path: `/medical-store/transaction/estimate-entry/edit/:id`,
    Component: <EditEstimateEntry />,
    permission: "estimate.edit"
  },

  // stock-transfer-entry

  {
    path: `/medical-store/transaction/stock-transfer-entry/add`,
    Component: <AddStockTransferEntry />,
    permission: "stocktransfer.add"
  },
  {
    path: `/medical-store/transaction/stock-transfer-entry/list`,
    Component: <ListStockTransferEntry />,
    permission: "stocktransfer.list"
  },
  {
    path: `/medical-store/transaction/stock-transfer-entry/edit/:id`,
    Component: <EditStockTransferEntry />,
    permission: "stocktransfer.edit"
  }
];

export const medicalStoreReportRoutes = [];
